var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("brandsController", [
    "$scope",
    "randomService",
    "urlService",
    "elasticService",
    "catalogService",
    "$filter",
    function (
        $scope,
        randomService,
        urlService,
        elasticService,
        catalogService,
        $filter
    ) {
        $scope.brandslistings = [];
        $scope.initialize = function (prdType, fp) {
            $scope.productType = prdType;
            $scope.fp = fp.toLowerCase() === "true";
            getBrands();
        };

        $scope.filteredProductDefinitions = function (productDefinitions, def) {
            return Object.values(productDefinitions).filter(function (
                definition
            ) {
                return definition
                    .replace(/\s+/g, "")
                    .toLowerCase()
                    .includes(def);
            });
        };

        //#region get
        function getBrands() {
            console.log($scope.productType);
            var design = "";
            try {
                design = $scope.filteredProductDefinitions(
                    catalogService.productDefinition,
                    $scope.productType
                );
                design =
                    design && design.length > 0
                        ? design[0]
                        : catalogService.capitalizeFirstLetter(
                              $scope.productType
                          );
            } catch (error) {
                design = "stockdesign";
            }

            if ($scope.productType.toLowerCase() == "all") {
                $scope.definition = "all";
            } else if (
                $scope.productType.toLowerCase() == "printart" ||
                $scope.productType.toLowerCase() == "vectorart"
            ) {
                $scope.definition = "Vector Arts";
            } else if (
                $scope.productType.toLowerCase() == "designs" ||
                $scope.productType.toLowerCase() == "stockdesign"
            ) {
                $scope.definition = "Embroidery Designs";
            } else if (
                $scope.productType.toLowerCase() == "designpack" ||
                $scope.productType.toLowerCase() == "packs"
            ) {
                $scope.definition = "Design Packs";
            } else {
                $scope.definition = $filter("pluralProductType")(design);
            }

            elasticService
                .getElasticData(elasticService.buildBrands(design, $scope.fp))
                .then(function (response) {
                    $scope.brandslistings =
                        response.data.aggregations.brands.buckets;
                    if ($scope.fp) {
                        var filteredbrandlistings =
                            $scope.brandslistings.filter(function (brand) {
                                return brand.doc_count > 10;
                            });
                        $scope.brandslistings = filteredbrandlistings;
                    }
                    if ($scope.brandslistings.length > 0) {
                        getBrandUrls();
                        getBrandDefinitions();
                    }
                });
        }

        function getBrandDefinitions() {
            var allBrands = _.pluck($scope.brandslistings, "key").join('","');
            elasticService
                .getElasticData(
                    elasticService.buildBrandDefinitionsInfoRequest(
                        allBrands,
                        $scope.brandslistings.length,
                        $scope.fp
                    )
                )
                .then(function (response) {
                    if (
                        response &&
                        response.data &&
                        response.data.aggregations
                    ) {
                        $scope.brandDefinitions =
                            response.data.aggregations.groupbyBrands.buckets;
                        elasticService
                            .getElasticData(
                                elasticService.buildBrandSampleInfoRequest(
                                    allBrands,
                                    $scope.brandslistings.length,
                                    $scope.fp
                                )
                            )
                            .then(function (response) {
                                if (
                                    response &&
                                    response.data &&
                                    response.data.aggregations
                                ) {
                                    $scope.brandSampleItems =
                                        response.data.aggregations.groupbyBrands.buckets;
                                    angular.forEach(
                                        $scope.brandslistings,
                                        function (brand) {
                                            brand.samples = [];
                                            brand.definitions = [];
                                            var brandSamples =
                                                $scope.brandSampleItems.filter(
                                                    function (s) {
                                                        return (
                                                            s.key.toLowerCase() ==
                                                            brand.key.toLowerCase()
                                                        );
                                                    }
                                                )[0];
                                            brandSamples = angular.isDefined(
                                                brandSamples
                                            )
                                                ? brandSamples.groupbyBrands
                                                      .hits.hits
                                                : [];
                                            var brandDefinitions =
                                                $scope.brandDefinitions.filter(
                                                    function (d) {
                                                        return (
                                                            d.key.toLowerCase() ==
                                                            brand.key.toLowerCase()
                                                        );
                                                    }
                                                )[0];
                                            brandDefinitions =
                                                angular.isDefined(
                                                    brandDefinitions
                                                )
                                                    ? brandDefinitions
                                                          .groupbyDef.buckets
                                                    : [];
                                            brand.definitions.push(
                                                brandDefinitions
                                            );
                                            brand.samples.push(
                                                randomService.getRandomItemsfromListArray(
                                                    brandSamples,
                                                    4
                                                )
                                            );
                                        }
                                    );
                                }
                            });
                    }
                });
        }

        $scope.getImageUrl = function (definitionName, vendor, prdId) {
            vendor = vendor.replace(/ /g, "_");
            return urlService.getImageUrl({
                catalogId: vendor,
                definitionName: definitionName,
                size: "medium",
                sku: prdId,
            });
        };

        $scope.getProductUrl = function (definitionName, vendor, name, itemId) {
            return urlService.getProductUrl({
                definitionName: definitionName,
                catalogId: vendor,
                name: name,
                sku: itemId,
            });
        };

        $scope.getBrandDefinitionUrl = function (brand, definition) {
            if (angular.isDefined(brand) && angular.isDefined(definition)) {
                return urlService
                    .getBrandListingUrl(brand, definition, $scope.fp)
                    .replace(/^\//, "");
            }
        };

        function getBrandUrls() {
            if ($scope.brandslistings && $scope.brandslistings.length > 0) {
                $scope.brandslistings.forEach(function (brand) {
                    brand.pageUrl = urlService.getBrandListingUrl(
                        brand.key,
                        $scope.productType,
                        $scope.fp
                    );
                });
            }
        }
    },
]);
